var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_8539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2676_8539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2676_8539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z",
    fill: "#00AFCC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.995C2 2.722 2.232 2.5 2.5 2.5C2.776 2.5 3 2.716 3 2.995V5.005C3 5.278 2.768 5.5 2.5 5.5C2.224 5.5 2 5.284 2 5.005V2.995ZM3 4.995C3 4.722 3.232 4.5 3.5 4.5C3.776 4.5 4 4.716 4 4.995V7.005C4 7.278 3.768 7.5 3.5 7.5C3.224 7.5 3 7.284 3 7.005V4.995ZM3 8.995C3 8.722 3.232 8.5 3.5 8.5C3.776 8.5 4 8.716 4 8.995V11.005C4 11.278 3.768 11.5 3.5 11.5C3.224 11.5 3 11.284 3 11.005V8.995ZM2 10.995C2 10.722 2.232 10.5 2.5 10.5C2.776 10.5 3 10.716 3 10.995V13.005C3 13.278 2.768 13.5 2.5 13.5C2.224 13.5 2 13.284 2 13.005V10.995ZM2 7C2 6.724 2.232 6.5 2.5 6.5C2.776 6.5 3 6.732 3 7C3 7.276 2.768 7.5 2.5 7.5C2.224 7.5 2 7.268 2 7ZM3 3C3 2.724 3.232 2.5 3.5 2.5C3.776 2.5 4 2.732 4 3C4 3.276 3.768 3.5 3.5 3.5C3.224 3.5 3 3.268 3 3ZM2 8C2 7.724 2.232 7.5 2.5 7.5C2.776 7.5 3 7.732 3 8C3 8.276 2.768 8.5 2.5 8.5C2.224 8.5 2 8.268 2 8ZM3 13C3 12.724 3.232 12.5 3.5 12.5C3.776 12.5 4 12.732 4 13C4 13.276 3.768 13.5 3.5 13.5C3.224 13.5 3 13.268 3 13ZM2 9C2 8.724 2.232 8.5 2.5 8.5C2.776 8.5 3 8.732 3 9C3 9.276 2.768 9.5 2.5 9.5C2.224 9.5 2 9.268 2 9Z",
    fill: "#DAC21D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.5C12.8807 9.5 14 8.38071 14 7C14 5.61929 12.8807 4.5 11.5 4.5C10.1193 4.5 9 5.61929 9 7C9 8.38071 10.1193 9.5 11.5 9.5Z",
    fill: "#FFC600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.5L9 9.5L11.5 10.5L14 9.5L15 7.5V10.5L11.5 11.5L8 10.5V7.5Z",
    fill: "#FFC600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 1H2C1.17157 1 0.5 1.67157 0.5 2.5V13.5C0.5 14.3284 1.17157 15 2 15H19C19.8284 15 20.5 14.3284 20.5 13.5V2.5C20.5 1.67157 19.8284 1 19 1Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_8539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKz);
export default __webpack_public_path__ + "static/media/kz.a4c9ae9528d735c2c34eb3e228969b8e.svg";
export { ForwardRef as ReactComponent };